import { render, staticRenderFns } from "./ActivationPage.vue?vue&type=template&id=2e7d71a7&"
import script from "./ActivationPage.vue?vue&type=script&lang=js&"
export * from "./ActivationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports